export const ADD_NOTIFICATION = 'notification/ADD_NOTIFICATION';

export default {
	ADD_NOTIFICATION,
};
